import React from 'react';
import { Box, Typography } from '@mui/material';
import PinchZoom from './PinchZoom';

export default function DocumentPhoto({
  renderPreview,
  loading,
  setLoading,
  documentData,
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      {loading ? (
        <Typography sx={{ color: '#4b4949ff' }}>
          이미지를 불러오는 중...
        </Typography>
      ) : (
        <PinchZoom
          wrapperStyle={{
            width: '100%',
            height: '100%',
          }}
          componentWrapperStyle={{
            width: '100%',
            height: '100%',
          }}
          contents={
            <img
              src={renderPreview}
              alt={
                documentData?.FILE_NM ||
                documentData?.TITLE ||
                '이미지 미리보기'
              }
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
              }}
              onLoad={() => setLoading(false)}
              onError={() => {
                console.error('이미지 로드 실패');
                setLoading(false);
              }}
            />
          }
        />
      )}
    </Box>
  );
}
